import Sendunit from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    sendunits: [],
    filteredCollection: [],
    current: new Sendunit(),
    pool: []
  },
  getters: {
    getCollection: state => state.sendunits,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.sendunits.find(sendunit => sendunit.id === id),
    getCurrent: state => state.current,
    getPool: state => state.pool
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/sendunits',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((sendunit) => {
            commit('addSendunitToCollection', { sendunitData: sendunit })
            return getters.getById(sendunit.id)
          })

          commit('addSendunitToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    create({ commit, getters }, model) {
      return this.dispatch('post', {
        path: 'v1/sendunits',
        data: model.getJSON()
      }).then((res) => {

        commit('addSendunitToCollection', { sendunitData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/sendunits/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addSendunitToCollection', { sendunitData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/sendunits/' + id
      }).then((res) => {

        commit('removeSendunitFromCollection', id)

        return res
      })
    },
    getPool ({ commit, getters }) {
      return this.dispatch('get', {
        path: 'v1/sendunitPools',
      }).then((res) => {
        const data = deepGet(res, 'body.data')
        if (data) {

          commit('updatePool', res && res.body)

          return getters.getPool
        }

        return res
      })
    }
  },
  mutations: {
    addSendunitToCollection(state, { sendunitData, opts }) {
      addToCollection(this, state.sendunits, sendunitData, Sendunit, opts)
    },
    addSendunitToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeSendunitFromCollection(state, sendunitId) {
      const index = state.sendunits.findIndex(el => el.id === sendunitId)

      if (index === -1) {
        console.warn(`Could not find/delete sendunit ${sendunitId}`)
        return
      }

      state.sendunits.splice(index, 1)
    },
    clearCollection(state) {
      state.sendunits = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    updateCurrent (state, sendunit) {
      state.current = sendunit
    },
    resetCurrent (state) {
      state.current = new Sendunit()
    },
    updatePool (state, pool) {
      state.pool = pool.data
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sendunit/store.js